import { mutator } from 'satcheljs';
import {
    addInsertLinkViewState,
    onUploadDone,
    removeInsertLinkViewState,
} from '../actions/internalActions';
import getInsertLinkViewState from '../selectors/getInsertLinkViewState';
import InsertLinkViewState from '../store/schema/InsertLinkViewState';
import getStore from '../store/store';
import { InsertLinkFailureType } from '../types/InsertLinkFailureType';

mutator(addInsertLinkViewState, actionMessage => {
    const store = getStore();
    const InsertLinkViewState: InsertLinkViewState = {
        linkId: actionMessage.linkId,
        isRetrievingSharingLink: true,
        file: actionMessage.file,
        insertFailureType: InsertLinkFailureType.Unknown,
        upsellProperties: actionMessage.upsellProperties,
        displayText: actionMessage.displayText,
    };

    store.insertLinks.set(actionMessage.linkId, InsertLinkViewState);
});

mutator(removeInsertLinkViewState, actionMessage => {
    const store = getStore();
    store.insertLinks.delete(actionMessage.linkId);
});

mutator(onUploadDone, actionMessage => {
    const viewState = getInsertLinkViewState(actionMessage.linkId);
    if (viewState) {
        viewState.file = actionMessage.file;
        viewState.upsellProperties = null;
    }
});
